/**
 * Frontend helper to clean up text artifacts often found when copying from PDFs.
 */

const anchorWords = [
    'fits', 'with', 'in', 'for', 'system', 'and', 'from', 'network',
    'connection', 'combined', 'power', 'supply', 'topologies', 'centralized',
    'decentralized', 'omneo', 'ip', 'multi', 'channel', 'amplifier', 'public'
];

/**
 * Core function to split merged words based on anchor list.
 */
export const cleanText = (text) => {
    if (!text || typeof text !== 'string') return text;

    // Normalize special dashes (non-breaking, en-dash, em-dash) to standard hyphen
    let cleaned = text.replace(/[\u2011\u2012\u2013\u2014\u2015]/g, '-');

    // 1. Split merged words using word-based logic
    const words = cleaned.split(' ');
    const resultWords = [];

    words.forEach(word => {
        let found = false;
        // Check for merged anchors at the end of a word (e.g., "Addressfits")
        for (const anchor of anchorWords) {
            if (word.toLowerCase().endsWith(anchor) && word.length > anchor.length) {
                const prefix = word.slice(0, word.length - anchor.length);
                const suffix = word.slice(word.length - anchor.length);

                // Guard: don't split "within"
                if (suffix.toLowerCase() === 'in' && prefix.toLowerCase() === 'with') {
                    continue;
                }

                // Guard: don't split if separated by punctuation (e.g. hyphens)
                if (!/^[a-z0-9]+$/i.test(prefix.slice(-1)) || !/^[a-z0-9]+$/i.test(suffix[0])) {
                    continue;
                }

                resultWords.push(prefix);
                resultWords.push(suffix);
                found = true;
                break;
            }
            // Check for merged anchors at the beginning (e.g., "withDC")
            if (word.toLowerCase().startsWith(anchor) && word.length > anchor.length) {
                const prefix = word.slice(0, anchor.length);
                const suffix = word.slice(anchor.length);

                // Guard: don't split "within"
                if (prefix.toLowerCase() === 'with' && suffix.toLowerCase() === 'in') {
                    continue;
                }

                // Guard: don't split if separated by punctuation (e.g. hyphens)
                if (!/^[a-z0-9]+$/i.test(prefix.slice(-1)) || !/^[a-z0-9]+$/i.test(suffix[0])) {
                    continue;
                }

                resultWords.push(prefix);
                resultWords.push(suffix);
                found = true;
                break;
            }
        }
        if (!found) resultWords.push(word);
    });

    cleaned = resultWords.join(' ');

    // 2. Fix multiple spaces and newlines
    cleaned = cleaned.replace(/\s+/g, ' ').trim();

    // 3. Fix words like "PublicAddress" (CamelCase merges)
    cleaned = cleaned.replace(/([a-z])([A-Z])/g, '$1 $2');

    return cleaned;
};
